import { StyledInfoBox, StyledInfoOutlinedIcon, StyledInfoTypography } from "../styles";

interface InfoMessageProps {
    message: string;
}

export default function InfoMessage({ message }: InfoMessageProps) {
    return (
        <StyledInfoBox>
          <StyledInfoOutlinedIcon />
          <StyledInfoTypography variant="body2">{message}</StyledInfoTypography>
        </StyledInfoBox>
    )
}